import { InputAdornment, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

function ModalVTUpdate(props) {
	const {
    vTypesModalCreateString,
    vTypesMCVtypeString,
    vTypesMCDescString,
		vTypesMCEstimatedTimeString,
    saveString,
  } = useTranslationHook();

  var vtNameForUPlaceholder = localStorage.getItem('vtNameForUpdate');
  var vtDescriptionForUPlaceholder = localStorage.getItem('vtDescForUpdate');
  var vtEstimatedDurationForUPlaceholder = localStorage.getItem('vtEstimatedDurationForUpdate');

  const [vtName, setVTName] = useState(vtNameForUPlaceholder);
  const [description, setDescription] = useState(vtDescriptionForUPlaceholder);
  const [estimatedDuration, setEstimatedDuration] = useState(vtEstimatedDurationForUPlaceholder);

  const resetFormFields = () => {
    setVTName(localStorage.getItem('vtNameForUpdate'));
    setDescription(localStorage.getItem('vtDescForUpdate'));
  };

  function updateVisitType(event) {
    event.preventDefault();
    var updateVisitTypeId = localStorage.getItem('visitTypeIdForUpdate');
    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateVisitType/${updateVisitTypeId}`,
        {
          vt_name: vtName,
          description: description,
					estimatedDuration: estimatedDuration,
        }, {
          headers: {
            'Authorization': 'bearer ' + localStorage.getItem('token')
          }
        }
      )
      .then(
        (response) => {
          hide();
        },
        (error) => {
          console.log(error);
          getToast({ status: 'error', title: 'Error al actualizar tipo de servicio. Vuelve a intentarlo.' });
        }
      );
  }

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Tipo de servicio actualizado exitosamente en la base de datos.' });
    props.getVisitTypesData();
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {vTypesModalCreateString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='update-vt-form' onSubmit={updateVisitType}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={vTypesMCVtypeString}
                type='text'
                value={vtName}
                onChange={(e) => setVTName(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={vTypesMCEstimatedTimeString}
                type='number'
                value={estimatedDuration}
                onChange={(e) => setEstimatedDuration(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>hrs</InputAdornment>
                  ),
                }}
                ad
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                multiline
                sx={{ width: '100%' }}
                label={vTypesMCDescString}
                rows={4.5}
                type='text'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          form='update-vt-form'
          type='submit'
          className='update-modal-button'
        >
          {saveString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalVTUpdate;
